import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviInterventionPreventiveState } from './state';

export const getters: GetterTree<SuiviInterventionPreventiveState, RootState> = {
    getSuiviInterventionsItems(state) {
        return state.interventions;
    },
    getSuiviInterventionFilterStatus(state): Array<string> {
        return state.filterStatus;
    },
    getSuiviInterventionFilterPredictedDateFrom(state): string {
        return state.filterPredictedDateFrom;
    },
    getSuiviInterventionFilterPredictedDateTo(state): string {
        return state.filterPredictedDateTo;
    },
    getSuiviInterventionFilterSiteIds(state): Array<number> {
        return state.filterSiteIds;
    },
    getSuiviInterventionFilterInterventionId(state): string {
        return state.filterInterventionId;
    },
    getSuiviInterventionFilterGroupeIds(state): Array<number> {
        return state.filterGroupeIds;
    },
    getSuiviInterventionFilterSousGroupeIds(state): Array<number> {
        return state.filterSousGroupeIds;
    },
    getSuiviInterventionFilterEquipementIds(state): Array<number> {
        return state.filterEquipementIds;
    },
    getSuiviInterventionsIsLoading(state) {
        return state.isLoading;
    },
    getSuiviInterventionsFilterSite(state) {
        return state.filterSiteIds;
    },
    getSuiviInterventionsPage(state) {
        return state.page;
    },
    getSuiviInterventionsNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviInterventionsScroll(state) {
        return state.scroll;
    },
    getSuiviInterventionsSort(state) {
        return state.sort;
    },
    getSuiviInterventionsCount(state) {
        return state.count;
    },
    getSuiviInterventionsTableHeader(state) {
        return state.tableHeader;
    },
    getSuiviInterventionsExportXlsIsLoading(state) {
        return state.isExportXlsLoading;
    },
};
